import React from 'react'

import Footer from '../../../componenets/footer/Footer'
import ReportContainer from '../../../containers/thrustarea/report/ReportContainer'

function TAReport() {
  return (
    <div>
        {/* <Header /> */}
        {/* <Navbar /> */}
        <ReportContainer />
        {/* <Footer /> */}
    </div>
  )
}

export default TAReport